import cn from './cn.js'
import en from './en.js'

const pc_lang = {
	cn,
	en
}
export default pc_lang
